import { validateAdaptiveRtStages } from '@/api/modules/calculatorApi';

/**
 * Пересчитать gate (матрица структур, common_structures) с учётом structure_aliases.
 * @param {import('@/stores/adaptiveRtStore').useAdaptiveRtStore} store
 * @returns {Promise<object|null>}
 */
export async function refreshAdaptiveRtWizardValidation(store) {
  if (!store?.canRunWizardValidate) return null;
  const payload = store.buildValidatePayload();
  const data = await validateAdaptiveRtStages(payload);
  store.applyWizardValidation(data);
  return data;
}

/**
 * @param {object|null|undefined} validation
 */
export function wizardValidationHasStructureMatrix(validation) {
  const rows = validation?.structure_matrix?.rows;
  return Array.isArray(rows) && rows.length > 0;
}

export function wizardValidationPlansMissing(validation) {
  return (validation?.stages || []).some(
    (stage) => Array.isArray(stage?.issues) && stage.issues.includes('plan_not_found'),
  );
}
